import {
  Component,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import {
  CategoryItem,
  ContactItem,
  CurrencyModel,
  TransactionTypeEnum,
  OutlineItem,
} from '../../models/base.models';
import { ApiService } from '../../services/api.service';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'formly-field-system-transaction-date-time',
  encapsulation: ViewEncapsulation.None,
  styles: [
    `
      .child-value-container {
        padding-left: 2.5rem !important;
      }
      .ng-value-label .child-value-container {
        padding-left: 0 !important;
      }
    `,
  ],
  template: `
    <div class="mb-3">
      <label class="form-label" [for]="field.id">
        {{ field.props.label }}
        <span *ngIf="field.props.required" aria-hidden="true">*</span></label
      >
      <div class="input-group input-group-solid">
        <span (click)="d.click()" class="input-group-text">
          <i class="ki-duotone ki-calendar fs-2"
            ><span class="path1"></span><span class="path2"></span
          ></i>
        </span>
        <input
        #d
          class="form-control form-control-solid"
          type="text"
          mwlFlatpickr
          [ngClass]="{
            'is-invalid': formControl.invalid && formControl.touched
          }"
          [maxDate]="maxDate"
          [id]="field.id"
          [placeholder]="field.props.placeholder"
          [formControl]="formControl"
          [convertModelValue]="true"
          [enableTime]="true"
          [enableSeconds]="false"
          dateFormat="Y-M-d (H:i)"
        />
      </div>
    </div>
  `,
})
export class systemTransactionDateTimeFieldType
  extends FieldType<FieldTypeConfig>
  implements OnInit, OnDestroy
{
  maxDate: Date = new Date()
  contactsList: ContactItem[] = [];
  currentSpaceId: number;

  currentTransactionType: TransactionTypeEnum = TransactionTypeEnum.expense;
  constructor(private api: ApiService) {
    super();
  }

  ngOnDestroy(): void {
    this.formControl?.reset();
  }

  async ngOnInit() {
    // this.field.formControl.setValue(new Date());
    this.currentSpaceId = +this.field.props.attributes['space_id'];
    // await this.watchControlChange()
  }

  async getSpaceContacts(
    spaceId: number = this.currentSpaceId,
    type: TransactionTypeEnum = this.currentTransactionType
  ) {
    let request$ = this.api.getSpaceContacts(spaceId);
    let response = await lastValueFrom(request$);

    return response;
  }

  async watchControlChange() {

  }
}
